import { useLocation } from 'react-router-dom'
import { Badge } from '@mui/material'

import { useT } from '@clara/locale'
import { theme } from '@clara/ui'

import { useGlobalStateContext } from '@/store/global/use-global-state'
import { NavigationItem, NavigationList } from '@clara/layout-next'
import { getActiveTab } from '@/utils/url'
import { useMemo } from 'react'

const TabBadge = ({
  count,
  children,
  active,
}: {
  count: number
  children: React.ReactNode
  active: boolean
}) => {
  const color = active
    ? theme.palette.v3.content.info
    : theme.palette.v3.content.low_emphasis
  const backgroundColor = active
    ? theme.palette.v3.bg.info
    : theme.palette.v3.bg.disabled
  return (
    <Badge
      sx={{
        paddingRight: `${count ? 24 : 0}px !important`,
        span: { right: '8px' },
        'span.MuiBadge-badge': {
          color,
          backgroundColor,
        },
      }}
      badgeContent={count > 99 ? '99+' : count}
    >
      {children}
    </Badge>
  )
}

export const LayoutTabs = () => {
  const { t } = useT('reimbursements')

  const { canApprove, canPay, tabCount } = useGlobalStateContext()
  const location = useLocation()

  const [isPendingActive, isPayActive] = useMemo(
    () => getActiveTab(location.pathname),
    [location.pathname],
  )

  if (!canApprove && !canPay) return null

  return (
    <NavigationList>
      <NavigationItem href="/reimbursements">
        {t('nav.item.overview')}
      </NavigationItem>
      {canApprove && (
        <NavigationItem
          href="/reimbursements/pending"
          label={
            <TabBadge count={tabCount.pendingApproval} active={isPendingActive}>
              {t('nav.item.pending')}
            </TabBadge>
          }
        />
      )}
      {canPay && (
        <NavigationItem
          href="/reimbursements/pay"
          label={
            <TabBadge count={tabCount.pendingPayment} active={isPayActive}>
              {t('nav.item.pay')}
            </TabBadge>
          }
        />
      )}
    </NavigationList>
  )
}
